import { render, staticRenderFns } from "./ChatEventComponent.vue?vue&type=template&id=65c59984&"
import script from "./ChatEventComponent.vue?vue&type=script&lang=js&"
export * from "./ChatEventComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports